import React, { useEffect, useState } from 'react';
import { Box, Typography, CircularProgress, Card, CardContent, Grid } from '@mui/material';

const formatDistance = (meters) => (meters / 1000).toFixed(2) + ' km';
const formatDuration = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return `${h > 0 ? h + 'h ' : ''}${m}m ${s}s`;
};
const formatDate = (dateStr) => new Date(dateStr).toLocaleDateString();

const StravaActivities = () => {
    const [activities, setActivities] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch('/api/strava/my-activities')
            .then((res) => {
                if (!res.ok) throw new Error('Error while fetching activities');
                return res.json();
            })
            .then((data) => {
                setActivities(data);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false);
            });
    }, []);

    if (loading) return <Box sx={{ textAlign: 'center', my: 4 }}><CircularProgress /></Box>;
    if (error) return <Box sx={{ textAlign: 'center', my: 4 }}><Typography color="error">{error}</Typography></Box>;
    if (!activities.length) return <Box sx={{ textAlign: 'center', my: 4 }}><Typography>No Strava activities found.</Typography></Box>;

    return (
        <Box sx={{ mt: 6, mb: 2 }}>
            <Box sx={{ background: 'white', borderRadius: 4, boxShadow: '0 4px 24px rgba(255,107,107,0.10)', p: { xs: 2, md: 4 }, maxWidth: 900, mx: 'auto' }}>
                <Typography variant="h4" fontWeight={700} gutterBottom sx={{ mb: 4, textAlign: 'left' }}>
                    My latest Strava activities
                </Typography>
                <Grid container spacing={3} justifyContent="flex-start">
                    {activities.map((act) => (
                        <Grid item xs={12} md={6} key={act.id}>
                            <Card sx={{ minWidth: 250, borderRadius: 4, boxShadow: '0 4px 24px rgba(255,107,107,0.10)', mb: 2 }}>
                                <CardContent>
                                    <Typography variant="h6" fontWeight={700} gutterBottom sx={{ textAlign: 'left' }}>{act.name}</Typography>
                                    <Typography sx={{ textAlign: 'left' }}>Distance: {formatDistance(act.distance)}</Typography>
                                    <Typography sx={{ textAlign: 'left' }}>Duration: {formatDuration(act.moving_time)}</Typography>
                                    <Typography sx={{ textAlign: 'left' }}>Date: {formatDate(act.start_date_local)}</Typography>
                                    <Typography sx={{ textAlign: 'left' }}>Type: {act.type}</Typography>
                                    <Typography sx={{ textAlign: 'left' }}>Average speed: {(act.average_speed * 3.6).toFixed(2)} km/h</Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
};

export default StravaActivities; 
